import { useReducedMotion } from 'framer-motion';
import type { ReactNode } from 'react';

interface WaveCardProps {
  children: ReactNode;
  className?: string;
}

// A4 "Card_tile_wave" from animation.md — layered waves rise behind the content
// for a liquid-fill feel. Use sparingly on ONE highlight tile. Recolored to a
// cyan/blue gradient at low opacity, slow motion, reduced-motion aware.
export function WaveCard({ children, className = '' }: WaveCardProps) {
  const reduce = useReducedMotion();
  return (
    <div className={`relative h-full overflow-hidden rounded-2xl border border-[#074EDC]/30 bg-[#04081e] backdrop-blur-md ${className}`}>
      {!reduce && (
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-2/3" aria-hidden>
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              className="absolute bottom-0 left-1/2 h-[200%] w-[200%] -translate-x-1/2 rounded-[42%]"
              style={{
                background:
                  i === 0
                    ? 'rgba(7,78,220,0.16)'
                    : i === 1
                      ? 'rgba(255,140,0,0.14)'
                      : 'rgba(74,172,0,0.12)',
                animation: `ticca-wave ${16 + i * 4}s linear infinite`,
                animationDelay: `${i * -3}s`,
              }}
            />
          ))}
        </div>
      )}
      <style>{`@keyframes ticca-wave { 0% { transform: translateX(-50%) rotate(0deg); } 100% { transform: translateX(-50%) rotate(360deg); } }`}</style>
      <div className="relative z-10 h-full">{children}</div>
    </div>
  );
}
